module.exports = __webpack_public_path__ + "img/visibility_off_black (2).ac769d01.svg";